import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

export function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-white py-8 dark:border-gray-600 dark:bg-black">
      <div className="container-app">
        <div className="flex flex-col items-center gap-4 text-center sm:flex-row sm:justify-between sm:text-left">
          {/* Links */}
          <nav className="flex flex-wrap justify-center gap-4 text-sm sm:gap-6">
            <Link
              to="/about"
              className="text-gray-600 hover:text-accent dark:text-gray-200"
            >
              {t('footer.about')}
            </Link>
            <Link
              to="/privacy"
              className="text-gray-600 hover:text-accent dark:text-gray-200"
            >
              {t('footer.privacy')}
            </Link>
            <Link
              to="/terms"
              className="text-gray-600 hover:text-accent dark:text-gray-200"
            >
              {t('footer.terms')}
            </Link>
          </nav>

          {/* Support link */}
          <a
            href="https://patreon.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm text-gray-600 hover:text-accent dark:text-gray-200"
          >
            <Heart className="h-4 w-4" aria-hidden="true" />
            {t('footer.support')}
          </a>
        </div>

        {/* Copyright */}
        <div className="mt-6 text-center text-xs text-gray-600 dark:text-gray-200">
          <p>&copy; {currentYear} Do You Like This Work?</p>
        </div>
      </div>
    </footer>
  );
}
